import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import AppNav from './components/AppNav';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TreePage from './pages/TreePage';
import MemberPage from './pages/MemberPage';
import MembersPage from './pages/MembersPage';
import AddMemoryPage from './pages/AddMemoryPage';
import SendInvitationPage from './pages/SendInvitationPage';
import MemoriesPage from './pages/MemoriesPage';
import InvitationsPage from './pages/InvitationsPage';
import CulturalPage from './pages/CulturalPage';
import CulturalTermDetailPage from './pages/CulturalTermDetailPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import AboutPage from './pages/AboutPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <AppNav>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/family-tree" element={<ProtectedRoute><TreePage /></ProtectedRoute>} />
          <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
          <Route path="/members/:id" element={<ProtectedRoute><MemberPage /></ProtectedRoute>} />
          <Route path="/memories/new" element={<ProtectedRoute><AddMemoryPage /></ProtectedRoute>} />
          <Route path="/invitations/new" element={<ProtectedRoute><SendInvitationPage /></ProtectedRoute>} />
          <Route path="/memories" element={<ProtectedRoute><MemoriesPage /></ProtectedRoute>} />
          <Route path="/invitations" element={<ProtectedRoute><InvitationsPage /></ProtectedRoute>} />
          <Route path="/cultural-terms" element={<ProtectedRoute><CulturalPage /></ProtectedRoute>} />
          <Route path="/cultural-terms/:termId" element={<ProtectedRoute><CulturalTermDetailPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><HelpPage /></ProtectedRoute>} />

          {/* Default */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AppNav>
    </AuthProvider>
  );
}

export default App;